<template>
  <div class="header-container">
    <div class="l-content">
      <el-button
        style="margin-right: 20px"
        @click="handleMenu"
        icon="el-icon-menu"
        size="mini"
      ></el-button>
    </div>
    <div class="r-content">
      <el-dropdown @command="handleClick">
        <span class="el-dropdown-link">
          <img class="user" src="../assets/toplogo.png" alt="" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="userProfile">个人中心</el-dropdown-item>
          <el-dropdown-item command="updatePassword">修改密码</el-dropdown-item>
          <el-dropdown-item command="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { loginOut } from "@/api";
export default {
  data() {
    return {};
  },
  methods: {
    handleMenu() {
      this.$store.commit("collapseMenu");
    },
    handleClick(command) {
      if (command === "userProfile") {
        this.$store.commit("updateUserProfileDialogVisibility", true);
      } else if (command === "logout") {
        console.log("logout");
        loginOut()
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success("退出成功");
              //清除localStorage的所有信息
              localStorage.clear();
              this.$router.go(0);
              this.$router.push({ name: "login" });
            } else {
              //清除localStorage的所有信息
              localStorage.clear();
              this.$router.go(0);
              this.$router.push({ name: "login" });
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      } else if (command === "updatePassword") {
        this.$store.commit("updateUpdatePasswordDialogVisibility", true);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header-container {
  padding: 0 20px;
  height: 60px;
  background-color: #6c6edc;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .text {
    color: #fff;
    font-size: 14px;
    margin-left: 10px;
  }
  .l-content {
    display: flex;
    align-items: center;
  }
}

.user {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>
